import React from 'react';
import { Sparkles, RotateCcw } from 'lucide-react';
import { OABLineItem } from '../types/oab';

export interface OABDraftPayload {
  folio: string;
  fechaEmision: string;
  tasaBCV: number;
  notas: string;
  lines: OABLineItem[];
  savedAt: string;
}

export interface OABDraftRestoreModalProps {
  isOpen: boolean;
  pendingDraft: OABDraftPayload | null;
  onRestore: () => void;
  onDiscardAndStartFresh: () => void;
}

export const OABDraftRestoreModal: React.FC<OABDraftRestoreModalProps> = ({
  isOpen,
  pendingDraft,
  onRestore,
  onDiscardAndStartFresh
}) => {
  if (!isOpen || !pendingDraft) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 backdrop-blur-md p-4 animate-fade-in no-print">
      <div className="bg-surface border border-brand-500/50 rounded-2xl w-full max-w-md p-5 sm:p-6 shadow-2xl flex flex-col items-center text-center space-y-4 ring-1 ring-brand-500/30">
        <div className="w-12 h-12 rounded-2xl bg-brand-500/20 text-brand-400 border border-brand-500/40 flex items-center justify-center shadow-inner">
          <Sparkles className="w-6 h-6 animate-pulse" />
        </div>
        <div>
          <h3 className="text-base font-bold text-slate-100 tracking-tight">
            Borrador de Solicitud Detectado
          </h3>
          <p className="text-xs text-slate-300 mt-1.5 leading-relaxed">
            Se encontró una orden en curso con <strong className="text-brand-400">{pendingDraft.lines.length} material(es)</strong> guardada localmente ({pendingDraft.savedAt ? new Date(pendingDraft.savedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'reciente'}).
          </p>
          <p className="text-[11px] text-slate-400 mt-1">
            ¿Deseas restaurar tus cantidades y prioridades personalizadas o empezar una requisición nueva?
          </p>
        </div>

        <div className="w-full flex flex-col sm:flex-row gap-2 pt-2">
          <button
            type="button"
            onClick={onRestore}
            className="flex-1 flex items-center justify-center gap-2 py-2.5 px-4 bg-brand-500 hover:bg-brand-600 text-slate-950 font-bold rounded-xl text-xs transition shadow-lg shadow-brand-500/20 active:scale-95"
          >
            <Sparkles className="w-4 h-4" />
            <span>Restaurar Borrador</span>
          </button>
          <button
            type="button"
            onClick={onDiscardAndStartFresh}
            className="flex-1 flex items-center justify-center gap-1.5 py-2.5 px-4 bg-surfaceHigh hover:bg-surfaceHighest text-slate-300 border border-borderSubtle rounded-xl text-xs font-semibold transition active:scale-95"
          >
            <RotateCcw className="w-3.5 h-3.5 text-slate-400" />
            <span>Empezar Nuevo</span>
          </button>
        </div>
      </div>
    </div>
  );
};
